
import { defineComponent } from "vue";

export default defineComponent({
  name: "ButtonRequest",
  props: {
    text: {
      type: String,
    },
  },
});
